import React from "react";
import { useLang } from "@/context/LanguageContext";
import { CtaTrio } from "@/components/common/CtaButtons";
import { Reveal } from "@/components/common/Section";

// Final conversion block. Carries data-hide-appointment so the floating
// appointment button fades out when this block enters the viewport.
export default function FinalCta({ title, text }) {
  const { t } = useLang();
  return (
    <section data-hide-appointment className="bg-nek-navy py-20 sm:py-28" data-testid="final-cta">
      <div className="nek-container">
        <Reveal className="mx-auto max-w-3xl text-center">
          <h2 className="nek-h2 text-white">{title || t.finalCta.title}</h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/70">{text || t.finalCta.text}</p>
          <div className="mt-8 flex justify-center">
            <CtaTrio variant="dark" className="!justify-center" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
